import Axios, { AxiosInstance } from 'axios';
import EndpointFactory from 'axios-endpoints';

import useInterceptors from '../interceptor';
import commerceInterceptor from '../interceptor/interceptors/commerce';

const API: AxiosInstance = useInterceptors(Axios.create(), [commerceInterceptor]);

const Endpoint = EndpointFactory(API);

// commerce
const storefront = 'storefront';
export const checkoutEndpoint = new Endpoint<{ slug: string }>(({ slug }) => `/${storefront}/${slug}`);
export const checkoutPaymentEndpoint = new Endpoint<{ slug: string }>(({ slug }) => `/${storefront}/${slug}/payment`);
export const checkoutEarlyRenewEndpoint = new Endpoint<{ contractId: string }>(({ contractId }) => `/${storefront}/renewal/contract/${contractId}`);
export const zipCodeNotFoundEndpoint = new Endpoint(() => `/${storefront}/zip-code/not-found`);

// order
const orders = 'orders';
export const ordersEndpoint = new Endpoint<{ orderId: string }>(({ orderId }) => `/${storefront}/${orders}/${orderId}`);

// contract
const contracts = 'contracts';
export const contractEndpoint = new Endpoint<{ contractId: string|number }>(({ contractId }) => `/${storefront}/${contracts}/${contractId}`);
export const recurrenceEndpoint = new Endpoint<{ contractId: string, actionType: string }>(
  ({ contractId, actionType }) => `/${storefront}/${contracts}/action-request/${contractId}/${actionType}`
);

// upsell
const upsell = 'upsell';
export const upsellEndpoint = new Endpoint<{ orderId: string }>(({ orderId }) => `/${storefront}/${upsell}/order/${orderId}`);
export const upsellOrderEndpoint = new Endpoint<{ upsellId: string, orderId: string }>(
  ({ upsellId, orderId }) => `/${storefront}/${upsell}/${upsellId}/order/${orderId}`);

// cart
const cart = 'cart';
export const cartCouponEndpoint = new Endpoint<{ cartId: string }>(({ cartId }) => `/${storefront}/${cart}/${cartId}/coupon`);
export const paymentMethodEndpoint = new Endpoint<{ cartId: string }>(({ cartId }) => `/${storefront}/${cart}/${cartId}/payment`);

// checkout
const purchase = 'checkout/purchase';
export const purchaseEndpoint = new Endpoint(() => `/${storefront}/${purchase}`);
const renew = 'checkout/renew';
export const renewEndpoint = new Endpoint(() => `/${storefront}/${renew}`);

// recaptcha
const recaptcha = 'recaptcha';
export const verifyCaptchaEndpoint = new Endpoint(() => `/${recaptcha}`);
